import MybetDetailsRequestService from './mybet-details-request-service';
import MyBetDetailsModel from 'bto-models/mybets/model-mybet-details';

/**
   * Get print ticket data from api
   */

export default class PrintDataService {
  getData(bsgid) {
    return new Promise((resolve) => {
      this.callAPI(bsgid, resolve);
    });
  }
  /**
   * 
   * @param {Number} bsgId betslipGroup id
   * @param {Function} resolve callback function
   * @param {Boolean} isRetryCall optinal parametar for retry policy
   */
  callAPI(bsgId, resolve, isRetryCall = 2) {
    const mybetDetailsRequest = new MybetDetailsRequestService();
    mybetDetailsRequest.getParams.betSlipGroupID = bsgId;
    // if retry call add timestamp param to avoid reading from disk cache
    if (isRetryCall) {
      mybetDetailsRequest.getParams.ts = Date.now();
    }
    mybetDetailsRequest.execute(response => {
      // if API does not return data, make one more attempt after 2 seconds
      if (isRetryCall > 0 && (!response.data || response.data.i.length < 1)) {
        setTimeout(() => {
          this.callAPI(bsgId, resolve, isRetryCall - 1);
        }, 2000 * (3 - isRetryCall));
        return;
      }
      const betDetails = new MyBetDetailsModel(response.data);
      resolve(betDetails);
    });
  }
}
